import ClientEventCard from '@/components/client/client-event-card';
import ClientFunnelPipelineCard from '@/components/client/client-funnel-pipeline-card';
import {
	$appendClientDetailEvents,
	$clientDetailEvents,
	$setClientDetailEvents,
} from '@/entities/client-event.entity';
import { SOCKET_EVENTS } from '@/api/socket-events';
import { useClientVirtualFeed } from '@/hooks/use-client-virtual-feed';
import { useUnit } from 'effector-react';

interface ClientInstallFunnelListProps {
	clientId: string;
	enabled: boolean;
}

export default function ClientInstallFunnelList({ clientId, enabled }: ClientInstallFunnelListProps) {
	const [events, setEvents, appendEvents] = useUnit([
		$clientDetailEvents,
		$setClientDetailEvents,
		$appendClientDetailEvents,
	]);

	const { listRef, content } = useClientVirtualFeed({
		clientId,
		searchText: '',
		enabled,
		fetchEvent: SOCKET_EVENTS.getClientEvents,
		responseEvent: SOCKET_EVENTS.addClientEvents,
		items: events,
		setItems: setEvents,
		appendItems: appendEvents,
		getItemId: item => item.id,
		emptyLabel: 'Событий установки пока нет',
		renderItem: event => <ClientEventCard event={event} />,
	});

	return (
		<div ref={listRef} data-scroll-container className='h-full overflow-auto pr-1 px-1 grid gap-2'>
			<ClientFunnelPipelineCard events={events} />
			{content}
		</div>
	);
}
